import Rollbar from 'rollbar';
export const RollbarErrorTracking = (() => {
    const RollbarObj = new Rollbar({
        accessToken: "ee5d0a68ab9c4d8cb677a7056b18110b",
        captureUncaught: true,
        captureUnhandledRejections: true,
        payload: {
            environment: "Local",
            // The usual
            person: {
                id: 201,
                username: 'himanshu120',
                email: 'himanshumodi120@gmail.com'
            }
        }
    });
    const logErrorInfo = (info) => {
        RollbarObj.info(info);
    };
    const logErrorInRollbar = (error) => {
        throw new Error(error);
    };
    return {
        logErrorInfo,
        logErrorInRollbar
    };
})();
// function mapStateToProps(state) {
//     // debugger;
//     return { loginDataR: JSON.parse(AES.decrypt(state.authentication.user, 'TPT_CARGO_CONNECT').toString(enc.Utf8)) }
//   }
export default RollbarErrorTracking;